// This file is auto-generated by @hey-api/openapi-ts

export const $Body_resend_activation_email_users__user_uuid__resend_activation_email_post = {
    properties: {
        performed_by_user_uuid: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Performed By User Uuid'
        }
    },
    type: 'object',
    title: 'Body_resend_activation_email_users__user_uuid__resend_activation_email_post'
} as const;

export const $Body_reset_password_users__user_uuid__reset_password_post = {
    properties: {
        performed_by_user_uuid: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Performed By User Uuid'
        }
    },
    type: 'object',
    title: 'Body_reset_password_users__user_uuid__reset_password_post'
} as const;

export const $Body_send_activation_email_users__user_uuid__send_activation_email_post = {
    properties: {
        performed_by_user_uuid: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Performed By User Uuid'
        }
    },
    type: 'object',
    title: 'Body_send_activation_email_users__user_uuid__send_activation_email_post'
} as const;

export const $CreateTenant = {
    properties: {
        tenantName: {
            type: 'string',
            title: 'Tenantname'
        },
        domains: {
            items: {
                type: 'string'
            },
            type: 'array',
            title: 'Domains'
        },
        tenantTypes: {
            items: {
                type: 'string'
            },
            type: 'array',
            title: 'Tenanttypes'
        },
        tools: {
            items: {
                type: 'string'
            },
            type: 'array',
            title: 'Tools'
        },
        providerMetadata: {
            anyOf: [
                {
                    '$ref': '#/components/schemas/ProviderMetadataModel'
                },
                {
                    type: 'null'
                }
            ]
        },
        requesterMetadata: {
            anyOf: [
                {
                    '$ref': '#/components/schemas/RequesterMetadataModel'
                },
                {
                    type: 'null'
                }
            ]
        }
    },
    type: 'object',
    required: ['tenantName', 'domains', 'tenantTypes', 'tools', 'providerMetadata', 'requesterMetadata'],
    title: 'CreateTenant',
    description: 'The parameters a caller can use to create a new Tenant.'
} as const;

export const $CreateUser = {
    properties: {
        firstName: {
            type: 'string',
            title: 'Firstname'
        },
        lastName: {
            type: 'string',
            title: 'Lastname'
        },
        emailAddress: {
            type: 'string',
            title: 'Emailaddress'
        },
        password: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Password'
        },
        phoneNumber: {
            type: 'string',
            title: 'Phonenumber'
        },
        tenantId: {
            type: 'integer',
            title: 'Tenantid'
        },
        isAdmin: {
            type: 'boolean',
            title: 'Isadmin'
        },
        createUserInOkta: {
            type: 'boolean',
            title: 'Createuserinokta'
        },
        addUserToRmGroup: {
            anyOf: [
                {
                    type: 'boolean'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Addusertormgroup',
            default: false
        },
        oktaGroups: {
            anyOf: [
                {
                    items: {
                        type: 'string'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Oktagroups',
            default: []
        },
        addToProductInternalGroup: {
            anyOf: [
                {
                    type: 'boolean'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Addtoproductinternalgroup',
            default: false
        }
    },
    type: 'object',
    required: ['firstName', 'lastName', 'emailAddress', 'phoneNumber', 'tenantId', 'isAdmin', 'createUserInOkta'],
    title: 'CreateUser',
    description: 'The parameters a caller can use to create a new User.'
} as const;

export const $CreateUsers = {
    properties: {
        users: {
            items: {
                '$ref': '#/components/schemas/CreateUser'
            },
            type: 'array',
            title: 'Users'
        }
    },
    type: 'object',
    required: ['users'],
    title: 'CreateUsers',
    description: 'The parameters a caller can use to create new Users.'
} as const;

export const $DigitalMetadataWithEligibility = {
    properties: {
        digitalSiteId: {
            anyOf: [
                {
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Digitalsiteid',
            description: 'The digital site id of the provider.'
        },
        fulfillmentMethod: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Fulfillmentmethod',
            description: 'The fulfillment method of the provider.'
        },
        tenantId: {
            type: 'integer',
            title: 'Tenantid',
            description: 'The tenant id of the provider.'
        },
        isLiveDigitalFulfillment: {
            type: 'boolean',
            title: 'Islivedigitalfulfillment',
            description: 'Whether the provider is live for digital fulfillment.'
        },
        emr: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Emr',
            description: 'The EMR name for the provider.'
        },
        emrEnvironment: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Emrenvironment',
            description: 'The EMR environment for the provider.'
        },
        onboardingStatus: {
            anyOf: [
                {
                    '$ref': '#/components/schemas/DigitalOnboardingStatus'
                },
                {
                    type: 'null'
                }
            ],
            description: 'The DF onboarding status of the provider.'
        },
        addressFeedbackComplete: {
            anyOf: [
                {
                    type: 'boolean'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Addressfeedbackcomplete',
            description: 'Whether the address feedback has been completed.'
        },
        goLiveDate: {
            anyOf: [
                {
                    type: 'string',
                    format: 'date-time'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Golivedate',
            description: 'The go live date of the provider.'
        },
        eligibility: {
            anyOf: [
                {
                    type: 'boolean'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Eligibility',
            description: 'If EMR / environment combination is eligible for digital fulfillment'
        },
        selfServeEligibility: {
            anyOf: [
                {
                    type: 'boolean'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Selfserveeligibility',
            description: 'If EMR / environment combination is eligible for self serve onboarding for digital fulfillment'
        },
        emrConfigId: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Emrconfigid',
            description: 'The EMR config id for the provider. This is used to determine which tracker to show in the UI.'
        }
    },
    type: 'object',
    required: ['digitalSiteId', 'fulfillmentMethod', 'tenantId', 'isLiveDigitalFulfillment', 'addressFeedbackComplete', 'goLiveDate', 'eligibility', 'selfServeEligibility', 'emrConfigId'],
    title: 'DigitalMetadataWithEligibility',
    description: 'Pydantic Model of a DigitalMetadata with eligibility object.'
} as const;

export const $DigitalOnboardingStatus = {
    type: 'string',
    enum: ['EMR_SUBMITTED', 'DOCUSIGN_COMPLETED', 'CREDENTIALS_SUBMITTED', 'CREDENTIALS_TEST_SUCCESSFUL', 'CREDENTIALS_TEST_FAILED', 'BACKLOAD_COMPLETED', 'ENCOUNTER_FEEDBACK_COMPLETED', 'SCANNED_DOCUMENT_FEEDBACK_COMPLETED', 'QC_STARTED', 'QC_READY', 'QC_COMPLETED', 'QC_FAILED', 'INSTALLED'],
    title: 'DigitalOnboardingStatus'
} as const;

export const $EligibilityBase = {
    properties: {
        emrName: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Emrname',
            description: 'The name of the emr'
        },
        emrMethod: {
            anyOf: [
                {
                    '$ref': '#/components/schemas/EmrMethod'
                },
                {
                    type: 'null'
                }
            ],
            description: 'The method of the emr'
        },
        emrEnvironment: {
            anyOf: [
                {
                    '$ref': '#/components/schemas/EmrEnvironment'
                },
                {
                    type: 'null'
                }
            ],
            description: 'The environment of the emr'
        },
        isEligible: {
            type: 'boolean',
            title: 'Iseligible',
            description: 'Whether the emr / env combo is eligible for digital fulfillment.'
        },
        selfServeEligibility: {
            type: 'boolean',
            title: 'Selfserveeligibility',
            description: 'If EMR / environment combination is eligible for self serve onboarding for digital fulfillment'
        },
        emrConfigId: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Emrconfigid',
            description: 'The id of the EMR config to be used to render the correct tracker in the UI.'
        }
    },
    type: 'object',
    required: ['emrName', 'emrMethod', 'emrEnvironment', 'isEligible', 'selfServeEligibility', 'emrConfigId'],
    title: 'EligibilityBase',
    description: 'Pydantic Model of a Eligibility object.'
} as const;

export const $EmrEnvironment = {
    type: 'string',
    enum: ['CLOUD', 'ON_PREMISE', 'NOT_SURE'],
    title: 'EmrEnvironment'
} as const;

export const $EmrMethod = {
    type: 'string',
    enum: ['API', 'HEALTHJUMP', 'NONE'],
    title: 'EmrMethod'
} as const;

export const $HTTPValidationError = {
    properties: {
        detail: {
            items: {
                '$ref': '#/components/schemas/ValidationError'
            },
            type: 'array',
            title: 'Detail'
        }
    },
    type: 'object',
    title: 'HTTPValidationError'
} as const;

export const $MarkInvitedResponse = {
    properties: {
        usersInvited: {
            type: 'integer',
            title: 'Usersinvited',
            description: 'Number of REQUESTED users transitioned to INVITE_SENT.'
        },
        provisioned: {
            type: 'boolean',
            title: 'Provisioned',
            description: 'True if the tenant has a PROVISIONED event (always true on success).'
        }
    },
    type: 'object',
    required: ['usersInvited', 'provisioned'],
    title: 'MarkInvitedResponse',
    description: 'Response for POST /tenants/{tenant_uuid}/rm-v2/mark-invited.'
} as const;

export const $OktaGetGroupsResponse = {
    properties: {
        groups: {
            items: {
                '$ref': '#/components/schemas/OktaGroup'
            },
            type: 'array',
            title: 'Groups'
        }
    },
    type: 'object',
    required: ['groups'],
    title: 'OktaGetGroupsResponse'
} as const;

export const $OktaGroup = {
    properties: {
        id: {
            type: 'string',
            title: 'Id'
        },
        name: {
            type: 'string',
            title: 'Name'
        },
        description: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Description'
        }
    },
    type: 'object',
    required: ['id', 'name', 'description'],
    title: 'OktaGroup'
} as const;

export const $OktaUserBase = {
    properties: {
        email: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Email',
            description: 'Okta primary email (profile.email).'
        },
        secondEmail: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Secondemail',
            description: 'Okta secondary email (profile.secondEmail).'
        },
        status: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Status',
            description: 'Okta user status, e.g. ACTIVE.'
        },
        login: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Login',
            description: 'Okta login (profile.login).'
        },
        authMethod: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Authmethod',
            description: 'Best-effort auth method from the Okta credential provider: "SSO" (federated/social) or "Password".'
        }
    },
    type: 'object',
    title: 'OktaUserBase',
    description: 'An Okta user record returned by the Okta-users search.'
} as const;

export const $OktaUserExistence = {
    properties: {
        email: {
            type: 'string',
            title: 'Email'
        },
        exists: {
            type: 'boolean',
            title: 'Exists'
        },
        status: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Status'
        },
        authMethod: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Authmethod'
        }
    },
    type: 'object',
    required: ['email', 'exists'],
    title: 'OktaUserExistence'
} as const;

export const $OktaUsersExistRequest = {
    properties: {
        emails: {
            items: {
                type: 'string'
            },
            type: 'array',
            maxItems: 25,
            title: 'Emails'
        }
    },
    type: 'object',
    required: ['emails'],
    title: 'OktaUsersExistRequest'
} as const;

export const $OktaUsersExistResponse = {
    properties: {
        users: {
            items: {
                '$ref': '#/components/schemas/OktaUserExistence'
            },
            type: 'array',
            title: 'Users'
        }
    },
    type: 'object',
    required: ['users'],
    title: 'OktaUsersExistResponse'
} as const;

export const $OktaUsersResponse = {
    properties: {
        users: {
            items: {
                '$ref': '#/components/schemas/OktaUserBase'
            },
            type: 'array',
            title: 'Users',
            description: 'Matching Okta user records.'
        }
    },
    type: 'object',
    title: 'OktaUsersResponse',
    description: 'Model that captures the list of Okta users returned to the client.'
} as const;

export const $OtherEMREntriesBase = {
    properties: {
        tenantId: {
            type: 'integer',
            title: 'Tenantid',
            description: 'The tenant id of the provider that submitted the EMR.'
        },
        emr: {
            type: 'string',
            title: 'Emr',
            description: 'The EMR name for the provider.'
        }
    },
    type: 'object',
    required: ['tenantId', 'emr'],
    title: 'OtherEMREntriesBase',
    description: 'Pydantic Model of a OtherEMREntries object.'
} as const;

export const $PermissionBase = {
    properties: {
        id: {
            type: 'integer',
            title: 'Id',
            description: 'The ID of the Permission'
        },
        namespace: {
            type: 'string',
            title: 'Namespace',
            description: 'The namespace the permission belongs to.'
        },
        name: {
            type: 'string',
            title: 'Name',
            description: 'Unique name of the permission used for checking.'
        },
        description: {
            type: 'string',
            title: 'Description',
            description: 'Description of what the permissionc ontrols access to.'
        }
    },
    type: 'object',
    required: ['id', 'namespace', 'name', 'description'],
    title: 'PermissionBase',
    description: 'Pydantic Model of a Permission object.'
} as const;

export const $ProviderMetadataBase = {
    properties: {
        roiSiteIds: {
            anyOf: [
                {
                    items: {
                        type: 'integer'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Roisiteids',
            description: 'The roi site ids of the provider.'
        },
        roiProcessingSiteIds: {
            anyOf: [
                {
                    items: {
                        type: 'integer'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Roiprocessingsiteids',
            description: 'The roi processing site ids of the provider.'
        },
        cleanSiteIds: {
            anyOf: [
                {
                    items: {
                        type: 'integer'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Cleansiteids',
            description: 'The clean site ids of the provider.'
        },
        emrSiteIds: {
            anyOf: [
                {
                    items: {
                        type: 'integer'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Emrsiteids',
            description: 'The emr site ids of the provider.'
        },
        dataFoundationsFacilityIds: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Datafoundationsfacilityids',
            description: 'The data foundations facility ids associated with the provider.'
        },
        childHealthSystemIds: {
            anyOf: [
                {
                    items: {
                        type: 'string'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Childhealthsystemids',
            description: 'The health system ids of child tenants associated with the provider.'
        },
        isChildTenant: {
            anyOf: [
                {
                    type: 'boolean'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Ischildtenant',
            description: 'Whether the tenant is the child of another provider.'
        },
        emr: {
            anyOf: [
                {
                    additionalProperties: true,
                    type: 'object'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Emr',
            description: 'The emr associated with the provider.'
        }
    },
    type: 'object',
    required: ['roiSiteIds', 'roiProcessingSiteIds', 'cleanSiteIds', 'emrSiteIds', 'dataFoundationsFacilityIds'],
    title: 'ProviderMetadataBase',
    description: 'Pydantic Model of a ProviderMetadata object.'
} as const;

export const $ProviderMetadataModel = {
    properties: {
        dataFoundationsFacilityIds: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Datafoundationsfacilityids'
        },
        roiProcessingSiteIds: {
            anyOf: [
                {
                    items: {
                        type: 'integer'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Roiprocessingsiteids'
        },
        roiSiteIds: {
            anyOf: [
                {
                    items: {
                        type: 'integer'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Roisiteids'
        },
        cleanSiteIds: {
            anyOf: [
                {
                    items: {
                        type: 'integer'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Cleansiteids'
        },
        emrSiteIds: {
            anyOf: [
                {
                    items: {
                        type: 'integer'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Emrsiteids'
        },
        emr: {
            anyOf: [
                {
                    additionalProperties: true,
                    type: 'object'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Emr'
        }
    },
    type: 'object',
    title: 'ProviderMetadataModel',
    description: 'Provider Metadata parameters'
} as const;

export const $QaUserBase = {
    properties: {
        uuid: {
            type: 'string',
            title: 'Uuid',
            description: 'The uuid of the User.'
        },
        fullName: {
            type: 'string',
            title: 'Fullname',
            description: 'The first and last name of the User.'
        },
        email: {
            type: 'string',
            title: 'Email',
            description: 'The email associated with the User.'
        }
    },
    type: 'object',
    required: ['uuid', 'fullName', 'email'],
    title: 'QaUserBase'
} as const;

export const $QaUsersResponse = {
    properties: {
        users: {
            items: {
                '$ref': '#/components/schemas/QaUserBase'
            },
            type: 'array',
            title: 'Users',
            description: 'List of QA users returned to the client.'
        }
    },
    type: 'object',
    required: ['users'],
    title: 'QaUsersResponse'
} as const;

export const $RequesterMetadataBase = {
    properties: {
        lawsonId: {
            anyOf: [
                {
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Lawsonid',
            description: 'The lawson ids of the provider.'
        }
    },
    type: 'object',
    required: ['lawsonId'],
    title: 'RequesterMetadataBase',
    description: 'Pydantic Model of a RequesterMetadata object.'
} as const;

export const $RequesterMetadataModel = {
    properties: {
        lawsonId: {
            anyOf: [
                {
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Lawsonid'
        }
    },
    type: 'object',
    required: ['lawsonId'],
    title: 'RequesterMetadataModel',
    description: 'Requester Metadata parameters'
} as const;

export const $ResetOnboardingRequest = {
    properties: {
        email: {
            type: 'string',
            format: 'email',
            title: 'Email'
        }
    },
    type: 'object',
    required: ['email'],
    title: 'ResetOnboardingRequest'
} as const;

export const $RmV2CompleteResponse = {
    properties: {
        userUuid: {
            type: 'string',
            title: 'Useruuid',
            description: 'The uuid of the user who completed migration.'
        },
        rmV2MigratedState: {
            type: 'string',
            title: 'Rmv2Migratedstate',
            description: "The user's current RM v2 migration state."
        }
    },
    type: 'object',
    required: ['userUuid', 'rmV2MigratedState'],
    title: 'RmV2CompleteResponse',
    description: 'Response for POST /users/{user_uuid}/rm-v2/complete.'
} as const;

export const $RmV2MigratedState = {
    type: 'string',
    enum: ['REQUESTED', 'INVITE_SENT', 'COMPLETED', 'PEER_MIGRATED'],
    title: 'RmV2MigratedState',
    description: 'Migration state of a user during the RM v2 (Console) migration.'
} as const;

export const $RmV2OptInResponse = {
    properties: {
        tenantUuid: {
            type: 'string',
            title: 'Tenantuuid',
            description: 'The uuid of the tenant that was opted in.'
        },
        initiatedByUserUuid: {
            type: 'string',
            title: 'Initiatedbyuseruuid',
            description: 'The uuid of the user who triggered opt-in.'
        },
        usersRequested: {
            type: 'integer',
            title: 'Usersrequested',
            description: 'Number of users transitioned to REQUESTED.'
        },
        requestedAt: {
            anyOf: [
                {
                    type: 'string',
                    format: 'date-time'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Requestedat',
            description: 'Timestamp when the REQUESTED event was first recorded. Null if no users were eligible.'
        }
    },
    type: 'object',
    required: ['tenantUuid', 'initiatedByUserUuid', 'usersRequested', 'requestedAt'],
    title: 'RmV2OptInResponse'
} as const;

export const $TenantBase = {
    properties: {
        id: {
            anyOf: [
                {
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Id',
            description: 'The id of a Tenant.'
        },
        tenantUuid: {
            type: 'string',
            title: 'Tenantuuid',
            description: 'uuid associated with a Tenant.'
        },
        tenantName: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Tenantname',
            description: 'The name of a Tenant.'
        },
        domains: {
            anyOf: [
                {
                    items: {
                        type: 'string'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Domains',
            description: 'The domains associated with a Tenant.'
        },
        tenantTypes: {
            anyOf: [
                {
                    items: {
                        '$ref': '#/components/schemas/TenantTypes'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Tenanttypes',
            description: 'The types associated with a Tenant.'
        },
        tools: {
            anyOf: [
                {
                    items: {
                        '$ref': '#/components/schemas/TenantTools'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Tools',
            description: 'The tools associated with a Tenant.'
        },
        creationDate: {
            anyOf: [
                {
                    type: 'string',
                    format: 'date-time'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Creationdate',
            description: 'The creation date of the Tenant.'
        },
        updatedDate: {
            anyOf: [
                {
                    type: 'string',
                    format: 'date-time'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Updateddate',
            description: 'The updated date of the Tenant.'
        },
        parentTenants: {
            anyOf: [
                {
                    items: {
                        '$ref': '#/components/schemas/TenantBase'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Parenttenants',
            description: "The parent tenant(s) associated with this user's tenant."
        }
    },
    type: 'object',
    required: ['id', 'tenantUuid', 'tenantName', 'domains', 'tenantTypes', 'tools', 'creationDate', 'updatedDate'],
    title: 'TenantBase',
    description: 'Pydantic Model of a Tenant object.'
} as const;

export const $TenantOffboardDeletedData = {
    properties: {
        providerMetadataDeleted: {
            anyOf: [
                {
                    items: {
                        type: 'integer'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Providermetadatadeleted',
            description: 'List of deleted provider metadata PK IDs.'
        },
        requesterMetadataDeleted: {
            anyOf: [
                {
                    items: {
                        type: 'integer'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Requestermetadatadeleted',
            description: 'List of deleted requester metadata PK IDs.'
        },
        digitalMetadataDeleted: {
            anyOf: [
                {
                    items: {
                        type: 'integer'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Digitalmetadatadeleted',
            description: 'List of deleted digital metadata PK IDs.'
        },
        userGroupsDeleted: {
            anyOf: [
                {
                    items: {
                        type: 'integer'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Usergroupsdeleted',
            description: 'List of deleted user group PK IDs.'
        },
        userGroupAssociationsDeleted: {
            anyOf: [
                {
                    items: {
                        type: 'integer'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Usergroupassociationsdeleted',
            description: 'List of deleted user group association PK IDs.'
        },
        usersDeleted: {
            anyOf: [
                {
                    items: {
                        type: 'integer'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Usersdeleted',
            description: 'List of user IDs that were deleted during offboarding.'
        },
        providerVerificationsDeleted: {
            anyOf: [
                {
                    items: {
                        type: 'integer'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Providerverificationsdeleted',
            description: 'List of provider verification IDs that were deleted.'
        },
        phoneNumbersDeleted: {
            anyOf: [
                {
                    items: {
                        type: 'string'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Phonenumbersdeleted',
            description: 'List of phone numbers that were deleted.'
        },
        faxNumbersDeleted: {
            anyOf: [
                {
                    items: {
                        type: 'string'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Faxnumbersdeleted',
            description: 'List of fax numbers that were deleted.'
        },
        rmDataCoordinatesOffboarded: {
            anyOf: [
                {
                    items: {
                        type: 'integer'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Rmdatacoordinatesoffboarded',
            description: 'List of data coordinate PK IDs that were offboarded in Request Manager.'
        }
    },
    type: 'object',
    title: 'TenantOffboardDeletedData',
    description: 'Represents all data deleted during the tenant offboarding process.'
} as const;

export const $TenantRmV2MigrationStatus = {
    type: 'string',
    enum: ['NOT_STARTED', 'IN_PROGRESS', 'COMPLETED'],
    title: 'TenantRmV2MigrationStatus',
    description: 'Rollup migration status for a tenant in the RM v2 (Console) migration.'
} as const;

export const $TenantRmV2MigrationStatusResponse = {
    properties: {
        migrationStatus: {
            '$ref': '#/components/schemas/TenantRmV2MigrationStatus',
            description: 'Rollup migration status for the tenant.'
        },
        totalUsers: {
            type: 'integer',
            title: 'Totalusers',
            description: 'Total number of non-deleted users in the tenant.'
        },
        startedUsers: {
            type: 'integer',
            title: 'Startedusers',
            description: 'Number of users who have begun migration (non-null state).'
        },
        completedUsers: {
            type: 'integer',
            title: 'Completedusers',
            description: 'Number of users in COMPLETED state.'
        }
    },
    type: 'object',
    required: ['migrationStatus', 'totalUsers', 'startedUsers', 'completedUsers'],
    title: 'TenantRmV2MigrationStatusResponse',
    description: 'Response for GET /tenants/{tenant_uuid}/rm-v2/migration-status.'
} as const;

export const $TenantTools = {
    type: 'string',
    enum: ['AUDIT_MANAGEMENT_TOOL', 'MANUAL_UPLOAD_TOOL', 'RECORD_REQUEST', 'REQUEST_QUEUE', 'REQUEST_MANAGER'],
    title: 'TenantTools'
} as const;

export const $TenantTypes = {
    type: 'string',
    enum: ['LSEPS', 'ATTORNEY', 'INTERNAL', 'PROVIDER', 'TPO', 'ONBOARDING'],
    title: 'TenantTypes'
} as const;

export const $TenantWithGroups = {
    properties: {
        id: {
            anyOf: [
                {
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Id',
            description: 'The id of a Tenant.'
        },
        tenantUuid: {
            type: 'string',
            title: 'Tenantuuid',
            description: 'uuid associated with a Tenant.'
        },
        tenantName: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Tenantname',
            description: 'The name of a Tenant.'
        },
        domains: {
            anyOf: [
                {
                    items: {
                        type: 'string'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Domains',
            description: 'The domains associated with a Tenant.'
        },
        tenantTypes: {
            anyOf: [
                {
                    items: {
                        '$ref': '#/components/schemas/TenantTypes'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Tenanttypes',
            description: 'The types associated with a Tenant.'
        },
        tools: {
            anyOf: [
                {
                    items: {
                        '$ref': '#/components/schemas/TenantTools'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Tools',
            description: 'The tools associated with a Tenant.'
        },
        creationDate: {
            anyOf: [
                {
                    type: 'string',
                    format: 'date-time'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Creationdate',
            description: 'The creation date of the Tenant.'
        },
        updatedDate: {
            anyOf: [
                {
                    type: 'string',
                    format: 'date-time'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Updateddate',
            description: 'The updated date of the Tenant.'
        },
        parentTenants: {
            anyOf: [
                {
                    items: {
                        '$ref': '#/components/schemas/TenantBase'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Parenttenants',
            description: "The parent tenant(s) associated with this user's tenant."
        },
        userGroups: {
            items: {
                '$ref': '#/components/schemas/UserGroupPermissions'
            },
            type: 'array',
            title: 'Usergroups',
            description: 'The user groups associated with this Tenant.'
        }
    },
    type: 'object',
    required: ['id', 'tenantUuid', 'tenantName', 'domains', 'tenantTypes', 'tools', 'creationDate', 'updatedDate', 'userGroups'],
    title: 'TenantWithGroups',
    description: 'Pydantic Model of a Tenant with its user groups and permissions.'
} as const;

export const $TenantWithMetadata = {
    properties: {
        id: {
            anyOf: [
                {
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Id',
            description: 'The id of a Tenant.'
        },
        tenantUuid: {
            type: 'string',
            title: 'Tenantuuid',
            description: 'uuid associated with a Tenant.'
        },
        tenantName: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Tenantname',
            description: 'The name of a Tenant.'
        },
        domains: {
            anyOf: [
                {
                    items: {
                        type: 'string'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Domains',
            description: 'The domains associated with a Tenant.'
        },
        tenantTypes: {
            anyOf: [
                {
                    items: {
                        '$ref': '#/components/schemas/TenantTypes'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Tenanttypes',
            description: 'The types associated with a Tenant.'
        },
        tools: {
            anyOf: [
                {
                    items: {
                        '$ref': '#/components/schemas/TenantTools'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Tools',
            description: 'The tools associated with a Tenant.'
        },
        creationDate: {
            anyOf: [
                {
                    type: 'string',
                    format: 'date-time'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Creationdate',
            description: 'The creation date of the Tenant.'
        },
        updatedDate: {
            anyOf: [
                {
                    type: 'string',
                    format: 'date-time'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Updateddate',
            description: 'The updated date of the Tenant.'
        },
        parentTenants: {
            anyOf: [
                {
                    items: {
                        '$ref': '#/components/schemas/TenantBase'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Parenttenants',
            description: "The parent tenant(s) associated with this user's tenant."
        },
        providerMetadata: {
            anyOf: [
                {
                    '$ref': '#/components/schemas/ProviderMetadataBase'
                },
                {
                    type: 'null'
                }
            ],
            description: 'The provider metatdata of a Tenant.'
        },
        requesterMetadata: {
            anyOf: [
                {
                    '$ref': '#/components/schemas/RequesterMetadataBase'
                },
                {
                    type: 'null'
                }
            ],
            description: 'The requester metadata of a Tenant.'
        },
        digitalMetadata: {
            anyOf: [
                {
                    '$ref': '#/components/schemas/DigitalMetadataWithEligibility'
                },
                {
                    type: 'null'
                }
            ],
            description: 'The digital metadata of a Tenant.'
        }
    },
    type: 'object',
    required: ['id', 'tenantUuid', 'tenantName', 'domains', 'tenantTypes', 'tools', 'creationDate', 'updatedDate', 'providerMetadata', 'requesterMetadata', 'digitalMetadata'],
    title: 'TenantWithMetadata'
} as const;

export const $TenantsResponse = {
    properties: {
        tenants: {
            items: {
                '$ref': '#/components/schemas/TenantBase'
            },
            type: 'array',
            title: 'Tenants',
            description: 'List of tenants returned to the client.'
        }
    },
    type: 'object',
    required: ['tenants'],
    title: 'TenantsResponse',
    description: 'Model that captures the Tenant response sent to the client.'
} as const;

export const $TenantsWithGroupsResponse = {
    properties: {
        tenants: {
            items: {
                '$ref': '#/components/schemas/TenantWithGroups'
            },
            type: 'array',
            title: 'Tenants',
            description: 'List of tenants with user groups returned to the client.'
        }
    },
    type: 'object',
    required: ['tenants'],
    title: 'TenantsWithGroupsResponse',
    description: 'Model that captures the Tenants with groups response sent to the client.'
} as const;

export const $TenantsWithMetadataResponse = {
    properties: {
        tenants: {
            items: {
                '$ref': '#/components/schemas/TenantWithMetadata'
            },
            type: 'array',
            title: 'Tenants',
            description: 'List of tenants returned to the client.'
        }
    },
    type: 'object',
    required: ['tenants'],
    title: 'TenantsWithMetadataResponse',
    description: 'Model that captures list Tenant responses with metadata sent to the client.'
} as const;

export const $UpdateDigitalMetadata = {
    properties: {
        fulfillmentMethod: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Fulfillmentmethod'
        },
        isLiveDigitalFulfillment: {
            anyOf: [
                {
                    type: 'boolean'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Islivedigitalfulfillment'
        },
        emr: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Emr'
        },
        emrEnvironment: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Emrenvironment'
        },
        onboardingStatus: {
            anyOf: [
                {
                    '$ref': '#/components/schemas/DigitalOnboardingStatus'
                },
                {
                    type: 'null'
                }
            ]
        },
        addressFeedbackComplete: {
            anyOf: [
                {
                    type: 'boolean'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Addressfeedbackcomplete'
        },
        goLiveDate: {
            anyOf: [
                {
                    type: 'string',
                    format: 'date-time'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Golivedate'
        }
    },
    type: 'object',
    title: 'UpdateDigitalMetadata',
    description: 'Digital Metadata parameters'
} as const;

export const $UpdateDigitalMetadataByDigitalSiteId = {
    properties: {
        fulfillmentMethod: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Fulfillmentmethod'
        },
        isLiveDigitalFulfillment: {
            anyOf: [
                {
                    type: 'boolean'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Islivedigitalfulfillment'
        },
        emr: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Emr'
        },
        emrEnvironment: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Emrenvironment'
        },
        onboardingStatus: {
            anyOf: [
                {
                    '$ref': '#/components/schemas/DigitalOnboardingStatus'
                },
                {
                    type: 'null'
                }
            ]
        },
        addressFeedbackComplete: {
            anyOf: [
                {
                    type: 'boolean'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Addressfeedbackcomplete'
        },
        goLiveDate: {
            anyOf: [
                {
                    type: 'string',
                    format: 'date-time'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Golivedate'
        }
    },
    type: 'object',
    title: 'UpdateDigitalMetadataByDigitalSiteId',
    description: 'Digital Metadata parameters'
} as const;

export const $UpdateProviderMetadata = {
    properties: {
        dataFoundationsFacilityIds: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Datafoundationsfacilityids'
        },
        roiProcessingSiteIds: {
            anyOf: [
                {
                    items: {
                        type: 'integer'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Roiprocessingsiteids'
        },
        roiSiteIds: {
            anyOf: [
                {
                    items: {
                        type: 'integer'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Roisiteids'
        },
        cleanSiteIds: {
            anyOf: [
                {
                    items: {
                        type: 'integer'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Cleansiteids'
        },
        emrSiteIds: {
            anyOf: [
                {
                    items: {
                        type: 'integer'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Emrsiteids'
        },
        emr: {
            anyOf: [
                {
                    additionalProperties: true,
                    type: 'object'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Emr'
        }
    },
    type: 'object',
    title: 'UpdateProviderMetadata',
    description: 'Provider Metadata update parameters'
} as const;

export const $UpdateRequesterMetadata = {
    properties: {
        lawsonId: {
            anyOf: [
                {
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Lawsonid'
        }
    },
    type: 'object',
    title: 'UpdateRequesterMetadata'
} as const;

export const $UpdateTenant = {
    properties: {
        tenantName: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Tenantname'
        },
        domains: {
            anyOf: [
                {
                    items: {
                        type: 'string'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Domains'
        },
        tenantTypes: {
            anyOf: [
                {
                    items: {
                        type: 'string'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Tenanttypes'
        },
        tools: {
            anyOf: [
                {
                    items: {
                        type: 'string'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Tools'
        },
        providerMetadata: {
            anyOf: [
                {
                    '$ref': '#/components/schemas/UpdateProviderMetadata'
                },
                {
                    type: 'null'
                }
            ]
        },
        requesterMetadata: {
            anyOf: [
                {
                    '$ref': '#/components/schemas/UpdateRequesterMetadata'
                },
                {
                    type: 'null'
                }
            ]
        },
        digitalMetadata: {
            anyOf: [
                {
                    '$ref': '#/components/schemas/UpdateDigitalMetadata'
                },
                {
                    type: 'null'
                }
            ]
        },
        deleted: {
            anyOf: [
                {
                    type: 'boolean'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Deleted'
        }
    },
    type: 'object',
    title: 'UpdateTenant',
    description: 'The parameters a caller can use to edit a Tenant.'
} as const;

export const $UpdateUser = {
    properties: {
        tenantId: {
            anyOf: [
                {
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Tenantid'
        },
        firstName: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Firstname'
        },
        lastName: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Lastname'
        },
        emailAddress: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Emailaddress'
        },
        isAdmin: {
            anyOf: [
                {
                    type: 'boolean'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Isadmin'
        },
        termsAccepted: {
            anyOf: [
                {
                    type: 'boolean'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Termsaccepted'
        },
        termsAcceptedV2: {
            anyOf: [
                {
                    type: 'boolean'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Termsacceptedv2'
        },
        deleted: {
            anyOf: [
                {
                    type: 'boolean'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Deleted'
        },
        lastLoginTime: {
            anyOf: [
                {
                    type: 'string',
                    format: 'date-time'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Lastlogintime'
        }
    },
    type: 'object',
    title: 'UpdateUser',
    description: 'The parameters a caller can use to update a User.'
} as const;

export const $UpdateUserGroupRequest = {
    properties: {
        action: {
            '$ref': '#/components/schemas/UserGroupAction',
            description: "Action to perform: 'add' or 'remove'."
        },
        userGroupId: {
            type: 'integer',
            title: 'Usergroupid',
            description: 'ID of the user group to add or remove.'
        }
    },
    type: 'object',
    required: ['action', 'userGroupId'],
    title: 'UpdateUserGroupRequest',
    description: 'Request model for adding or removing a user group.'
} as const;

export const $UpdateUsers = {
    properties: {
        users: {
            items: {
                '$ref': '#/components/schemas/UpdateUser'
            },
            type: 'array',
            title: 'Users'
        }
    },
    type: 'object',
    required: ['users'],
    title: 'UpdateUsers',
    description: 'The parameters a caller can use to update Users.'
} as const;

export const $UserAliasBase = {
    properties: {
        id: {
            type: 'integer',
            title: 'Id',
            description: 'The ID of the User Alias.'
        },
        userId: {
            type: 'integer',
            title: 'Userid',
            description: 'The tenant_user.user_id this alias refers to.'
        },
        aliasEmail: {
            type: 'string',
            title: 'Aliasemail',
            description: 'The alias email associated with the user'
        }
    },
    type: 'object',
    required: ['id', 'userId', 'aliasEmail'],
    title: 'UserAliasBase',
    description: 'Pydantic Model of a User Alias object.'
} as const;

export const $UserBase = {
    properties: {
        userUuid: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Useruuid',
            description: 'The uuid of the User.'
        },
        id: {
            anyOf: [
                {
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Id',
            description: 'The id of the User.'
        },
        firstName: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Firstname',
            description: 'The first name of the User.'
        },
        lastName: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Lastname',
            description: 'The last name of the User.'
        },
        emailAddress: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Emailaddress',
            description: 'The email associated with the User.'
        },
        isAdmin: {
            type: 'boolean',
            title: 'Isadmin',
            description: 'This specifies if a user is an admin or not.'
        },
        tenantId: {
            anyOf: [
                {
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Tenantid',
            description: 'The id of the tenant that the user belongs with.'
        },
        tenant: {
            anyOf: [
                {
                    '$ref': '#/components/schemas/TenantBase'
                },
                {
                    type: 'null'
                }
            ],
            description: 'The dictionary representing the tenant that the user belongs to.'
        },
        termsAccepted: {
            type: 'boolean',
            title: 'Termsaccepted',
            description: 'This specifies if a user has agreed to the terms of service or not.'
        },
        termsAcceptedV2: {
            type: 'boolean',
            title: 'Termsacceptedv2',
            description: 'This specifies if a user has agreed to the v2 terms of service or not.'
        },
        parentTenants: {
            anyOf: [
                {
                    items: {
                        '$ref': '#/components/schemas/TenantBase'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Parenttenants',
            description: "The parent tenant(s) associated with this user's tenant."
        },
        permissions: {
            items: {
                '$ref': '#/components/schemas/PermissionBase'
            },
            type: 'array',
            title: 'Permissions',
            description: 'List of permissions the user has.'
        },
        userGroups: {
            items: {
                '$ref': '#/components/schemas/UserGroupBase'
            },
            type: 'array',
            title: 'Usergroups',
            description: 'List of user groups the user belongs to.'
        },
        userAliases: {
            items: {
                '$ref': '#/components/schemas/UserAliasBase'
            },
            type: 'array',
            title: 'Useraliases',
            description: "List of user's aliases."
        },
        isDatavanter: {
            type: 'boolean',
            title: 'Isdatavanter',
            description: 'Whether the user is a Datavanter. Read-only, set directly in the database.'
        },
        lastLoginTime: {
            anyOf: [
                {
                    type: 'string',
                    format: 'date-time'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Lastlogintime',
            description: 'The last time the user logged into a system. Not all applications update this for a user.'
        },
        rmV2MigratedState: {
            anyOf: [
                {
                    '$ref': '#/components/schemas/RmV2MigratedState'
                },
                {
                    type: 'null'
                }
            ],
            description: 'Migration state of the user during the RM v2 (Console) migration.'
        }
    },
    type: 'object',
    required: ['userUuid', 'id', 'firstName', 'lastName', 'emailAddress', 'isAdmin', 'tenantId', 'tenant', 'termsAccepted', 'termsAcceptedV2', 'permissions', 'userGroups', 'userAliases', 'isDatavanter', 'lastLoginTime'],
    title: 'UserBase',
    description: 'Pydantic Model of a User Object.'
} as const;

export const $UserGroupAction = {
    type: 'string',
    enum: ['add', 'remove'],
    title: 'UserGroupAction',
    description: 'Enum for user group actions.'
} as const;

export const $UserGroupBase = {
    properties: {
        id: {
            type: 'integer',
            title: 'Id',
            description: 'The ID of the User Group.'
        },
        displayName: {
            type: 'string',
            title: 'Displayname',
            description: 'The display name of the user group.'
        },
        type: {
            type: 'string',
            title: 'Type',
            description: 'The unique identifier of the type of user grouping this is.'
        }
    },
    type: 'object',
    required: ['id', 'displayName', 'type'],
    title: 'UserGroupBase',
    description: 'Pydantic Model of a User Group object.'
} as const;

export const $UserGroupPermissions = {
    properties: {
        id: {
            type: 'integer',
            title: 'Id',
            description: 'The ID of the User Group.'
        },
        displayName: {
            type: 'string',
            title: 'Displayname',
            description: 'The display name of the user group.'
        },
        type: {
            type: 'string',
            title: 'Type',
            description: 'The unique identifier of the type of user grouping this is.'
        },
        permissions: {
            items: {
                '$ref': '#/components/schemas/PermissionBase'
            },
            type: 'array',
            title: 'Permissions',
            description: 'List of permissions associated with this user group.'
        }
    },
    type: 'object',
    required: ['id', 'displayName', 'type', 'permissions'],
    title: 'UserGroupPermissions',
    description: 'Pydantic Model of a User Group object with associated permissions.'
} as const;

export const $UserGroupsPermissionsResponse = {
    properties: {
        userGroups: {
            items: {
                '$ref': '#/components/schemas/UserGroupPermissions'
            },
            type: 'array',
            title: 'Usergroups',
            description: 'List of user groups including associated permissions returned to the client.'
        }
    },
    type: 'object',
    required: ['userGroups'],
    title: 'UserGroupsPermissionsResponse',
    description: 'Model that captures the list of User Group including associated permissions response sent to the client.'
} as const;

export const $UserGroupsResponse = {
    properties: {
        userGroups: {
            items: {
                '$ref': '#/components/schemas/UserGroupBase'
            },
            type: 'array',
            title: 'Usergroups',
            description: 'List of user groups returned to the client.'
        }
    },
    type: 'object',
    required: ['userGroups'],
    title: 'UserGroupsResponse',
    description: 'Model that captures the list of User Group response sent to the client.'
} as const;

export const $UserResponse = {
    properties: {
        user: {
            '$ref': '#/components/schemas/UserBase',
            description: 'User returned to the client.'
        }
    },
    type: 'object',
    required: ['user'],
    title: 'UserResponse',
    description: 'Model that captures the User response sent to the client.'
} as const;

export const $UserRoleLookupItem = {
    properties: {
        userUuid: {
            type: 'string',
            title: 'Useruuid'
        }
    },
    type: 'object',
    required: ['userUuid'],
    title: 'UserRoleLookupItem'
} as const;

export const $UserRolesEntry = {
    properties: {
        userUuid: {
            type: 'string',
            title: 'Useruuid'
        },
        roleIds: {
            items: {
                type: 'integer'
            },
            type: 'array',
            title: 'Roleids'
        }
    },
    type: 'object',
    required: ['userUuid', 'roleIds'],
    title: 'UserRolesEntry'
} as const;

export const $UserRolesLookupRequest = {
    properties: {
        users: {
            items: {
                '$ref': '#/components/schemas/UserRoleLookupItem'
            },
            type: 'array',
            title: 'Users'
        }
    },
    type: 'object',
    required: ['users'],
    title: 'UserRolesLookupRequest'
} as const;

export const $UserRolesLookupResponse = {
    properties: {
        users: {
            items: {
                '$ref': '#/components/schemas/UserRolesEntry'
            },
            type: 'array',
            title: 'Users'
        }
    },
    type: 'object',
    required: ['users'],
    title: 'UserRolesLookupResponse'
} as const;

export const $UsersCountResponse = {
    properties: {
        total: {
            type: 'integer',
            title: 'Total',
            description: 'Total number of users matching the query, across all pages.'
        }
    },
    type: 'object',
    required: ['total'],
    title: 'UsersCountResponse',
    description: 'Total number of users matching a query — companion to the paginated /users/all list.'
} as const;

export const $UsersResponse = {
    properties: {
        users: {
            items: {
                '$ref': '#/components/schemas/UserBase'
            },
            type: 'array',
            title: 'Users',
            description: 'List of users returned to the client.'
        }
    },
    type: 'object',
    required: ['users'],
    title: 'UsersResponse',
    description: 'Model that captures the list of User response sent to the client.'
} as const;

export const $ValidationError = {
    properties: {
        loc: {
            items: {
                anyOf: [
                    {
                        type: 'string'
                    },
                    {
                        type: 'integer'
                    }
                ]
            },
            type: 'array',
            title: 'Location'
        },
        msg: {
            type: 'string',
            title: 'Message'
        },
        type: {
            type: 'string',
            title: 'Error Type'
        },
        input: {
            title: 'Input'
        },
        ctx: {
            type: 'object',
            title: 'Context'
        }
    },
    type: 'object',
    required: ['loc', 'msg', 'type'],
    title: 'ValidationError'
} as const;